(function () {
  function isProductPage() {
    return document.body && (
      document.body.classList.contains('template-product') ||
      String(document.body.className || '').indexOf('template-product') !== -1 ||
      location.pathname.indexOf('/products/') !== -1
    );
  }

  function q(sel, root) {
    return (root || document).querySelector(sel);
  }

  function sourceBlock(name) {
    var source = document.getElementById('stahlor-pdp-commerce-trust-v1-source');
    if (!source) return null;
    return source.querySelector('[data-stahlor-block="' + name + '"]');
  }

  function findBuyBox() {
    return q('.ltn__shop-details-content') ||
           q('.product-details-content') ||
           q('.product__info-wrapper') ||
           q('.shop-details-info') ||
           q('.summary.entry-summary');
  }

  function removeOldGuideIfExists() {
    document.querySelectorAll('.stahlor-pdp-guide-v1').forEach(function (el) {
      el.remove();
    });
  }

  function insertTrustBox() {
    if (document.querySelector('.stahlor-pdp-trustbox-v1[data-stahlor-live="1"]')) return;

    var src = sourceBlock('trustbox');
    var box = findBuyBox();
    if (!src || !box) return;

    var clone = src.cloneNode(true);
    clone.style.display = '';
    clone.setAttribute('data-stahlor-live', '1');

    var form = box.querySelector('form[action*="/cart/add"], form.cart, .product-form');

    if (form && form.parentNode) {
      form.insertAdjacentElement('afterend', clone);
    } else {
      box.appendChild(clone);
    }
  }

  function apply() {
    if (!isProductPage()) return;
    removeOldGuideIfExists();
    insertTrustBox();
  }

  document.addEventListener('DOMContentLoaded', function () {
    apply();
    setTimeout(apply, 300);
    setTimeout(apply, 1000);
    setTimeout(apply, 2000);
  });

  try {
    var timer = null;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(apply, 120);
    }).observe(document.documentElement, { childList: true, subtree: true });
  } catch(e) {}
})();